import {
  ActionIcon,
  Button,
  FileButton,
  Flex,
  Grid,
  Group,
  Loader,
  LoadingOverlay,
  ScrollArea,
  Select,
  Text,
  Title,
  Tooltip,
  TypographyStylesProvider,
  Popover,
  Avatar,
  Badge,
  Divider,
  TextInput,
  Pagination,
} from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/dropzone/styles.css";
import { randomId, useDisclosure, useDebouncedValue } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import "@mantine/notifications/styles.css";
import {
  LocalizationMap,
  RenderPage,
  RenderPageProps,
  ScrollMode,
  SpecialZoomLevel,
  Viewer,
  Worker,
} from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { renderPremiumToolbar } from "../../component/PremiumPdfToolbar";
import { ContractSummaryPanel } from "../../component/ContractSummaryPanel";
import { proxyAvatar } from "../../_base/helper/ImageProxy";
import de_DE from "@react-pdf-viewer/locales/lib/vi_VN.json";
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import {
  IconCalendar,
  IconCommand,
  IconDownload,
  IconEdit,
  IconEye,
  IconMail,
  IconNoteOff,
  IconRecycle,
  IconSearch,
  IconSignature,
  IconTrash,
  IconUpload,
  IconUser,
  IconWritingSign,
  IconX,
  IconZoomIn,
} from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";
import { Rnd } from "react-rnd";
import {
  AvatarUtils,
  convertSignType,
  repositorySign,
  workerUrl,
} from "../../_base/_const/_constVar";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { GetStepSignModel } from "../../model/GetStepSignModel";
import { MessageResponse } from "../../model/MessageResponse";
import { SignAccessModel } from "../../model/SignAccessModel";
import "./Main.css";
import "./pdf.component.css";
import "./tab.component.css";
import { Image } from "@tiptap/extension-image";
import Signature, { SignatureRef, StrokeOptions } from "@uiw/react-signature";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Loading } from "../../_base/component/_layout/Loading";
import { SelectListItem } from "../../_base/model/_base/SelectListItemBase";
import { ListStepSign } from "../../model/SignPage";
import { SignRejectModel } from "../../model/SignRejectModel ";
import { Selection } from "@tiptap/extensions";
import { Link, RichTextEditor } from "@mantine/tiptap";
import "@mantine/tiptap/styles.css";
import { scrollModePlugin } from "@react-pdf-viewer/scroll-mode";
import Highlight from "@tiptap/extension-highlight";
import SubScript, { Subscript } from "@tiptap/extension-subscript";
import Superscript from "@tiptap/extension-superscript";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import { useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { formatDateTransfer } from "../../_base/extension/FormatDate";
import { getUsersSelect } from "../../const/getSelectApi";
import { TblComment } from "../../model/Tblcomment";
import { ImageCore } from "./ImageCore";
import { PdfFileView } from "./PdfFileView";
import PdfOnlyViewer from "./PdfOnlyViewer";

import { saveAs } from "file-saver";
import JSZip from "jszip";
import CommentModal from "../Func/CommentModal/CommentModal";
import { SimpleEditor } from "../../@/components/tiptap-templates/simple/simple-editor";
import HorizontalRule from "../../@/components/tiptap-node/horizontal-rule-node/horizontal-rule-node-extension";
import { TaskItem, TaskList } from "@tiptap/extension-list";
import Typography from "@tiptap/extension-typography";
import { ImageUploadNode } from "../../@/components/tiptap-node/image-upload-node";
import { handleImageUpload, MAX_FILE_SIZE } from "../../@/lib/tiptap-utils";
import { EcmNodeContent } from "../../model/EcmNodeContent";
import { getFileNames } from "../../_base/extension/Extension";
import { TagUsersSection, TagUser } from "../../_base/component/CommentComponents/TagUsersSection";
import { CommentAttachmentSection } from "../../_base/component/CommentComponents/CommentAttachmentSection";
import { AttachmentListModal } from "../../_base/component/CommentComponents/AttachmentListModal";
import { IconPaperclip } from "@tabler/icons-react";

interface SignResponse {
  Signature: string;
  Error: string | null;
  companyOrPerson: string;
}
interface TblDocumentCommand {
  id: number;
  code: string;
  name: string;
  active: boolean;
  doctypeId: number;
  attachments: string | null;
  signedDocument: string | null;
  // ...other properties
}

const USERS_PER_PAGE = 6;

const ViewTopage = () => {
  let params = useParams();
  const navigate = useNavigate();
  const [urlFile, setUrlFile] = useState<string>("");
  const [saveFile, setSaveFile] = useState<Uint8Array>();
  const [selectFile, setSelectFile] = useState<string>("");
  const [listFile, setListFile] = useState<Array<string>>([]);
  const [listFileAttr, setListFileAttr] = useState<Array<string>>([]);
  const [documentData, setDocument] = useState<GetStepSignModel>();
  const [documentInfo, setDocumentInfo] = useState<TblDocumentCommand>();
  const [listComment, setListComment] = useState<TblComment[]>();
  const [data, setData] = useState<Array<ListStepSign>>([]);
  const [employ, setEmployee] = useState<SelectListItem[]>([]);
  const [isView, setIsView] = useState<boolean>();
  const [searchParams] = useSearchParams();
  const [attachments, setAttachments] = useState<string>("");
  const [tagUsers, setTagUsers] = useState<TagUser[]>([]);
  const [isLoadingTagUsers, setIsLoadingTagUsers] = useState(false); // Thêm state này
  const [popoverOpened, setPopoverOpened] = useState(false);
  const [selectedUser, setSelectedUser] = useState<TagUser | null>(null);
  const [popoverPosition, setPopoverPosition] = useState({ x: 0, y: 0 });
  const [popoverTarget, setPopoverTarget] = useState<HTMLElement | null>(null);
  const editor11 = useEditor({
    extensions: [
      StarterKit,
      Underline,
      Link,
      Superscript,
      SubScript,
      Highlight,
      TextAlign.configure({ types: ["heading", "paragraph"] }),
    ],
    editorProps: {
      handlePaste(view, event, slice) {
        const clipboardData = event.clipboardData;
        const text = clipboardData?.getData("text/plain");

        if (text) {
          event.preventDefault();

          // Chuyển từng dòng thành 1 đoạn văn
          const lines = text
            .split(/\r?\n/)
            .filter((line) => line.trim() !== "")
            .map((line) => `<p>${line}</p>`)
            .join("");

          editor11?.commands.insertContent(lines);
          return true;
        }

        return false;
      },
    },
  });
  const [fileNameDownloadV2, setFileNameDownloadV2] = useState<
    EcmNodeContent[]
  >([]);
  const editor = useEditor({
    immediatelyRender: false,
    shouldRerenderOnTransaction: false,
    editorProps: {
      attributes: {
        autocomplete: "off",
        autocorrect: "off",
        autocapitalize: "off",
        "aria-label": "Main content area, start typing to enter text.",
        class: "simple-editor",
      },
    },
    extensions: [
      StarterKit.configure({
        horizontalRule: false,
        link: {
          openOnClick: false,
          enableClickSelection: true,
        },
      }),
      HorizontalRule,
      TextAlign.configure({ types: ["heading", "paragraph"] }),
      TaskList,
      TaskItem.configure({ nested: true }),
      Highlight.configure({ multicolor: true }),
      Image,
      Typography,
      // Superscript,
      // Subscript,
      Selection,
      ImageUploadNode.configure({
        accept: "image/*",
        maxSize: MAX_FILE_SIZE,
        limit: 10,
        upload: handleImageUpload,
        onError: (error) => console.error("Upload failed:", error),
      }),
    ],
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!params.id || Number.parseInt(params.id) < 1) {
      navigate("/method/approve-task");
    } else {
      if (searchParams.get("view") === "1") {
        setIsView(true);
      } else setIsView(false);
      fetchDocumentInfo(Number.parseInt(params.id));
      fetchDataEmployee();
      fetchTagUsers();
    }
  }, []);

  // Call fetchComments when documentInfo is available
  useEffect(() => {
    if (documentInfo?.id) {
      fetchComments(); // Call API sau khi có documentInfo
    }
  }, [documentInfo?.id]);

  const fetchDocumentInfo = async (id: number) => {
    try {
      const url = `/api/v1/TblDocument/update?id=${id}`;
      const response = await repositorySign.get<
        MessageResponse<TblDocumentCommand>
      >(url);

      if (response && response.httpStatusCode === 200 && response.success) {
        setDocumentInfo(response.data);

        // Xử lý tài liệu ký và đính kèm
        const documents: string[] = [];

        if (response.data.signedDocument) {
          documents.push(...response.data.signedDocument.split("||"));
          const urls = response.data.signedDocument.split("||");
          const getUserName = await getFileNames(urls);
          if (getUserName && getUserName.length > 0) {
            setFileNameDownloadV2((prev) => [...prev, ...getUserName]);
          }
        }

        if (response.data.attachments) {
          const attachmentFiles = response.data.attachments
            .split("||")
            .map((f) => f.trim());
          console.log("Attachment files:", attachmentFiles);
          setListFileAttr(attachmentFiles);
          const urls = response.data.attachments.split("||");
          const getUserName = await getFileNames(urls);
          if (getUserName && getUserName.length > 0) {
            setFileNameDownloadV2((prev) => [...prev, ...getUserName]);
          }
        }

        // Cập nhật listFile với files từ documentInfo
        if (documents.length > 0) {
          setListFile((prev) => {
            const combined = [...prev, ...documents];
            return Array.from(new Set(combined)); // Remove duplicates
          });

          // Set first file if no file selected yet
          if (!selectFile && documents.length > 0) {
            const firstFile = documents[0];
            const fileName = firstFile.split("/").pop() || "";
            setSelectFile(fileName);
            setUrlFile(firstFile);
          }
        }
      } else {
        NotificationExtension.Fails(
          response?.message || "Không thể tải thông tin tài liệu"
        );
      }
    } catch (error) {
      console.error("Error fetching document info:", error);
      NotificationExtension.Fails("Lỗi khi tải thông tin tài liệu");
    }
  };

  const fetchDataEmployee = async () => {
    const dataApi = await getUsersSelect();
    if (dataApi && dataApi.length > 0) {
      const filteredData = dataApi.filter((item) => item.text !== null);
      setEmployee(filteredData);
    }
  };

  const fetchTagUsers = async () => {
    setIsLoadingTagUsers(true); // Bắt đầu loading
    try {
      const response = await repositorySign.get<MessageResponse<TagUser[]>>(
        `/api/v1/users/get-all`
      );
      if (response && response.success) {
        setTagUsers(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching tag users:", error);
    } finally {
      setIsLoadingTagUsers(false); // Kết thúc loading
    }
  };

  const fetchComments = async () => {
    if (!documentInfo?.id) return;
    try {
      setLoading(true);
      const response = await repositorySign.get<MessageResponse<TblComment[]>>(
        `/api/v1/SignPage/get-comment?documentId=${documentInfo.id}`
      );

      if (response && response.success) {
        // Sort comments by creation date - newest first, oldest last
        const sortedComments = (response.data || []).sort(
          (a, b) =>
            new Date(b.createdAt ?? "").getTime() -
            new Date(a.createdAt ?? "").getTime()
        );
        setListComment(sortedComments);
      } else {
        NotificationExtension.Fails(
          response?.message || "Lỗi khi tải danh sách bình luận !"
        );
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
      NotificationExtension.Fails("Lỗi khi tải danh sách bình luận !");
    } finally {
      setLoading(false);
    }
  };

  // Function để convert @mention thành thẻ <a> với event handlers
  const renderCommentWithMentions = (content: string) => {
    if (!content || tagUsers.length === 0) return content;

    let processedContent = content;

    // Xử lý @(Báo cho cả nhóm)
    processedContent = processedContent.replace(
      /@\(Báo cho cả nhóm\)/g,
      '<a href="#" class="mention-link mention-all" style="color: #228be6; text-decoration: none; font-weight: 500; cursor: pointer;" title="Hover để xem thông tin">@(Báo cho cả nhóm)</a>'
    );

    // Xử lý mention của từng user
    tagUsers.forEach((user) => {
      const mentionRegex = new RegExp(
        `@\\(${user.name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\)`,
        "g"
      );
      processedContent = processedContent.replace(
        mentionRegex,
        `<a href="#" class="mention-link" data-user-id="${user.id}" style="color: #228be6; text-decoration: none; font-weight: 500; cursor: pointer;" title="Hover để xem thông tin">@(${user.name})</a>`
      );
    });

    return processedContent;
  };

  // Handle hover on mention links
  const handleMentionHover = (event: Event) => {
    event.preventDefault();
    const target = event.target as HTMLElement;

    // Lưu vị trí và element target
    setPopoverTarget(target);

    if (target.classList.contains("mention-all")) {
      // Hiển thị popup cho @Báo cho cả nhóm
      setSelectedUser({
        id: 0,
        userName: "All",
        name: "Báo cho cả nhóm",
        isAll: true,
      });
      setPopoverOpened(true);
    } else if (target.classList.contains("mention-link")) {
      const userId = target.getAttribute("data-user-id");
      if (userId) {
        const user = tagUsers.find((u) => u.id === parseInt(userId));
        if (user) {
          setSelectedUser(user);
          setPopoverOpened(true);
        }
      }
    }
  };

  // Handle mouse leave
  const handleMentionLeave = (event: Event) => {
    setPopoverOpened(false);
    setPopoverTarget(null);
  };

  // Attach event listeners to mention links
  useEffect(() => {
    const addMentionEventHandlers = () => {
      const mentionLinks = document.querySelectorAll(".mention-link");
      mentionLinks.forEach((link) => {
        link.addEventListener("mouseenter", handleMentionHover);
        link.addEventListener("mouseleave", handleMentionLeave);
      });
    };

    // Add listeners after comments are rendered
    const timer = setTimeout(addMentionEventHandlers, 100);

    return () => {
      clearTimeout(timer);
      // Clean up event listeners
      const mentionLinks = document.querySelectorAll(".mention-link");
      mentionLinks.forEach((link) => {
        link.removeEventListener("mouseenter", handleMentionHover);
        link.removeEventListener("mouseleave", handleMentionLeave);
      });
    };
  }, [listComment, tagUsers]);

  const fullName = localStorage.getItem("fullName");

  const [boundaryElm, setBoundaryElm] = useState<HTMLDivElement>();
  // const workerUrl = new URL(
  //   "pdfjs-dist/build/pdf.worker.min.js",
  //   import.meta.url
  // ).toString();
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: renderPremiumToolbar,
  });
  // const disableScrollPluginInstance = disableScrollPlugin();
  const pageNavigationPluginInstance = pageNavigationPlugin();
  const [selectedItemId, setSelectedItemId] = useState<string>("");
  const {
    GoToFirstPage,
    GoToLastPage,
    GoToNextPage,
    GoToPreviousPage,
    CurrentPageLabel,
    jumpToPage,
  } = pageNavigationPluginInstance;
  const scrollModePluginInstance = scrollModePlugin();
  const $svg = useRef<SignatureRef>(null);
  const [options, setOptions] = useState<StrokeOptions>({
    size: 5,
    smoothing: 0.5,
    thinning: 0.5,
    streamline: 0.3,
  });

  const urlFront =
    "https://files.hacom.vn/hacom/Local/4oLmMUArial-Unicode-Regular (4).ttf";
  const [fontBytesFE, setFontBytes] = useState<ArrayBuffer>();
  useEffect(() => {
    const fetchFont = async () => {
      try {
        const response = await fetch(urlFront);
        const fontData = await response.arrayBuffer();
        setFontBytes(fontData);
      } catch (error) {
        console.error("Error fetching font:", error);
      }
    };

    fetchFont();
  }, []); // Empty dependency array means it runs only on mount

  useEffect(() => {
    if (saveFile) setData([]);
  }, [saveFile]);

  const [listFileUpload, setListFileUpload] = useState<Array<SelectListItem>>(
    []
  );
  const [fileSign, setFileSign] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  const downloadAllFiles = async (type: number) => {
    //type 1: Tải xuống tài liệu đã ký
    //type 2: Tải xuống tài liệu đính kèm
    if (type === 1)
      if (!listFile || listFile.length === 0) {
        NotificationExtension.Info("Không có tài liệu để tải xuống!");
        return;
      }
    if (type === 2)
      if (!listFileAttr || listFileAttr.length === 0) {
        NotificationExtension.Info("Không có tài liệu để tải xuống!");
        return;
      }

    const listFileDownload = type === 1 ? listFile : listFileAttr;

    const zip = new JSZip();
    // Tải từng file và thêm vào zip
    await Promise.all(
      listFileDownload.map(async (fileUrl) => {
        const fileName =
          fileNameDownloadV2.find(
            (file) => file.fileName === fileUrl.split("/").pop()
          )?.originName ??
          fileUrl.split("/").pop() ??
          "Tài liệu";
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        zip.file(fileName, blob);
      })
    );
    // Đặt tên file zip theo ngày và giờ hiện tại
    const nameZip = documentInfo?.name || documentInfo?.code || "TaiLieu_";
    const now = new Date();
    const pad = (n: number) => n.toString().padStart(2, "0");
    const zipName =
      nameZip +
      `_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(
        now.getDate()
      )}.zip`;
    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, zipName);
    });
  };

  useEffect(() => {
    if (fileSign) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        const imageData = fileReader.result;
        const imageUrl = `${imageData}`;
        setImageUrl(imageUrl);
      };
      fileReader.readAsDataURL(fileSign ?? new Blob());
    } else setImageUrl(null);
  }, [fileSign]);

  function addComment() {
    let commentAttachmentUrls = "";
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thêm comment</Title>
        </>
      ),
      size: "70%",
      children: (
        <>
          <SimpleEditor editor={editor} />
          {editor && (
            <TagUsersSection
              tagUsers={tagUsers}
              editor={editor}
              USERS_PER_PAGE={USERS_PER_PAGE}
            />
          )}
          <CommentAttachmentSection
            onAttachmentsChange={(urls) => {
              commentAttachmentUrls = urls;
            }}
          />
        </>
      ),
      labels: { confirm: "Gửi", cancel: "Đóng" },
      onConfirm: async () => {
        let cmt = editor?.getHTML();
        if (!cmt) {
          NotificationExtension.Info("Chưa nhập comment !");
          return;
        }

        // Xử lý mention users
        const mentionedUserIds: number[] = [];
        const mentionRegex = /@\(([^)]+)\)/g;
        let match;

        while ((match = mentionRegex.exec(cmt)) !== null) {
          const mentionName = match[1];
          if (mentionName === "Báo cho cả nhóm") {
            mentionedUserIds.push(...tagUsers.map((u) => u.id));
          } else {
            const user = tagUsers.find((u) => u.name === mentionName);
            if (user && !mentionedUserIds.includes(user.id)) {
              mentionedUserIds.push(user.id);
            }
          }
        }

        // Chuyển \r hoặc \r\n thành <br>
        cmt = cmt.replace(/(\r\n|\r|\n)/g, "<br>");

        const urlApi = "/api/v1/SignPage/add-comment";
        var resSign = await repositorySign.post<MessageResponse<TblComment[]>>(
          urlApi,
          {
            documentId: documentInfo?.id,
            content: cmt,
            mentionUserIds:
              mentionedUserIds.length > 0 ? mentionedUserIds : undefined,
            att1: commentAttachmentUrls,
          }
        );

        if (resSign && resSign.httpStatusCode === 200) {
          if (resSign.success) {
            NotificationExtension.Success("Thành công !");
            // Call lại fetchComments để load comments mới
            await fetchComments();
            editor?.commands.clearContent();
            modals.closeAll();
          } else
            NotificationExtension.Fails(
              resSign.message.length > 0 ? resSign.message : "Thất bại !"
            );
        }
      },
      closeOnConfirm: false,
    });
  }

  const [visible, { toggle, open, close }] = useDisclosure(false);


  return (
    <>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              <Title size={15}>
                {" "}
                Đang mã hóa tài liệu và thực hiện ký. Quá trình có thể mất nhiều
                thời gian do chính sách bảo mật...
              </Title>
            </Flex>
          ),
        }}
      />
      {(documentData || documentInfo) && (
        <>
          <Grid>
            <Grid.Col span={{ base: 12, sm: 5 }}>
              <Flex
                gap="xs"
                justify="flex-start mr"
                align="center"
                direction="row"
                wrap="wrap"
              >
                <p style={{ marginRight: 10 }}>Chọn tài liệu</p>
                <Select
                  label=""
                  key={randomId()}
                  placeholder="Chọn..."
                  value={selectFile}
                  onChange={(e) => {
                    const _key = e ?? "";
                    setSelectFile(_key);
                    if (_key.length > 1) {
                      const file = listFile.find((x) => x.includes(_key));
                      if (file) setUrlFile(file);
                    }
                  }}
                  data={listFile.map((x) => ({
                    label:
                      fileNameDownloadV2.find(
                        (file) => file.fileName === x.split("/").pop()
                      )?.originName ??
                      x.split("/").pop() ??
                      "Tài liệu",
                    value: x.split("/")[x.split("/").length - 1],
                  }))}
                />
                <Button
                  leftSection={<IconDownload size={16} />}
                  onClick={() => downloadAllFiles(1)}
                >
                  Tải xuống
                </Button>
                <Button
                  leftSection={<IconDownload size={16} />}
                  variant="outline"
                  onClick={async () => {
                    if (!urlFile) {
                      NotificationExtension.Info("Không có file PDF để tải!");
                      return;
                    }
                    const fileName =
                      fileNameDownloadV2.find(
                        (file) => file.fileName === urlFile.split("/").pop()
                      )?.originName ??
                      urlFile.split("/").pop() ??
                      "TaiLieu.pdf";
                    const response = await fetch(urlFile);
                    const blob = await response.blob();
                    saveAs(blob, fileName);
                  }}
                >
                  Tải PDF
                </Button>
                {/* {documentData?.liststepsign?.typesigncustomer === 2 && (
                  <Button
                    leftSection={<IconSearch size={14} />}
                    color="teal"
                    variant="outline"
                    onClick={() => {
                      NotificationExtension.Info(
                        "Chức năng đang được phát triển!"
                      );
                    }}
                  >
                    Kiểm tra chữ ký số
                  </Button>
                )} */}
              </Flex>
              <Flex
                gap="xs"
                justify="flex-start"
                align="center"
                direction="row"
                wrap="wrap"
              >
                <p style={{ marginRight: 32 }}>Đính kèm</p>
                <Select
                  style={{ marginTop: 10 }}
                  label=""
                  key={randomId()}
                  placeholder="Chọn..."
                  value={selectFile}
                  onChange={(e) => {
                    const _key = e ?? "";
                    setSelectFile(_key);
                    if (_key.length > 1) {
                      const file = listFileAttr.find((x) => x.includes(_key));
                      if (file) setUrlFile(file);
                    }
                  }}
                  data={listFileAttr.map((x) => ({
                    label:
                      fileNameDownloadV2.find(
                        (file) => file.fileName === x.split("/").pop()
                      )?.originName ??
                      x.split("/").pop() ??
                      "Tài liệu",
                    value: x.split("/")[x.split("/").length - 1],
                  }))}
                />
                <Button
                  style={{ marginTop: 10 }}
                  leftSection={<IconDownload size={16} />}
                  onClick={() => downloadAllFiles(2)}
                >
                  Tải xuống
                </Button>
                <Button
                  style={{ marginTop: 10 }}
                  leftSection={<IconDownload size={16} />}
                  variant="outline"
                  onClick={async () => {
                    // Lấy file đính kèm đang chọn
                    const selectedAttrFile =
                      listFileAttr.find((x) => x.includes(selectFile)) ||
                      listFileAttr[0];
                    if (!selectedAttrFile) {
                      NotificationExtension.Info("Không có file PDF để tải!");
                      return;
                    }
                    const fileName =
                      fileNameDownloadV2.find(
                        (file) =>
                          file.fileName === selectedAttrFile.split("/").pop()
                      )?.originName ??
                      selectedAttrFile.split("/").pop() ??
                      "TaiLieu.pdf";
                    const response = await fetch(selectedAttrFile);
                    const blob = await response.blob();
                    saveAs(blob, fileName);
                  }}
                >
                  Tải PDF
                </Button>
                {/* {documentData?.liststepsign?.typesigncustomer === 2 && (
                  <Button
                    leftSection={<IconSearch size={14} />}
                    color="teal"
                    variant="outline"
                    onClick={() => {
                      NotificationExtension.Info(
                        "Chức năng đang được phát triển!"
                      );
                    }}
                  >
                    Kiểm tra chữ ký số
                  </Button>
                )} */}
              </Flex>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 7 }}>
              <Flex
                gap="md"
                justify={{ sm: "flex-start", lg: "flex-end" }}
                align="center"
                direction="row"
                wrap="wrap"
              >
                {/* <Button
                  size="xs"
                  onClick={async () => {
                    // Kiểm tra xem có file đính kèm hay không
                    if (!attachments || attachments.length === 0) {
                      NotificationExtension.Info("Không có file đính kèm");
                      return;
                    }

                    modals.openConfirmModal({
                      title: <Title order={4}>Xem file đính kèm</Title>,
                      size: "80%",
                      radius: "md",
                      children: <PdfFileView file={attachments} />,
                      confirmProps: { display: "none" },
                      cancelProps: { display: "none" },
                    });
                  }}
                  leftSection={<IconEye />}
                  variant="outline"
                  color="blue"
                >
                  Xem file đính kèm
                </Button> */}

                <Button
                  variant="outline"
                  color="grape"
                  leftSection={<IconEdit />}
                  onClick={async () => {
                    await addComment();
                  }}
                  size="xs"
                  loading={isLoadingTagUsers}
                  disabled={isLoadingTagUsers}
                >
                  {isLoadingTagUsers ? "Đang tải..." : "Viết comment"}
                </Button>
                <Button
                  onClick={() => navigate("/method/folders-task")}
                  variant="outline"
                  size="xs"
                  color="gray"
                  leftSection={<IconX />}
                >
                  Đóng
                </Button>
              </Flex>
            </Grid.Col>
          </Grid>

          <Grid>
            <Grid.Col span={{ base: 12, sm: 7, md: 7.5 }}>
              {urlFile && !isView && (
                <div className="e-card" id="weather_card">
                  <div
                    className="rpv-core__viewer"
                    style={{
                      border: "1px solid rgba(0, 0, 0, 0.3)",
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                    }}
                  >
                    <Group justify="center">
                      <div className="App" ref={(ref) => setBoundaryElm(ref!)}>
                        <Worker workerUrl={workerUrl}>
                          <Viewer
                            localization={de_DE as unknown as LocalizationMap}
                            fileUrl={saveFile ? saveFile : urlFile}
                            plugins={[
                              defaultLayoutPluginInstance,
                              pageNavigationPluginInstance,
                            ]}
                            scrollMode={ScrollMode.Vertical}
                            defaultScale={SpecialZoomLevel.ActualSize}
                          // renderPage={!isView ? renderPage : undefined}
                          />
                        </Worker>
                      </div>
                    </Group>
                  </div>
                </div>
              )}
              {urlFile &&
                urlFile.length > 0 &&
                urlFile.startsWith("http") &&
                isView && (
                  <div className="control-section">
                    <PdfOnlyViewer files={urlFile} />
                  </div>
                )}
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 5, md: 4.5 }}>
              {(documentInfo?.id ?? (params.id ? Number.parseInt(params.id) : 0)) > 0 ? (
                <ContractSummaryPanel documentId={documentInfo?.id ?? Number.parseInt(params.id!)} />
              ) : null}
              <div
                className="e-card"
                id="weather_card"
                style={{
                  position: "sticky",
                  top: 65,
                }}
              >
                <div className="e-card-header">
                  <div className="e-card-header-caption">
                    <div className="e-card-header-title e-card-3">
                      Chi tiết trao đổi
                    </div>
                    <ScrollArea mt={10} h={"80vh"} scrollbars="y">
                      <div style={{ padding: 0 }}>
                        {loading ? (
                          <Flex justify="center" align="center" py={50}>
                            <Loader size="md" />
                          </Flex>
                        ) : (
                          <>
                            {listComment?.map((itemComment, index) => (
                              <div
                                key={itemComment.id}
                                style={{
                                  background: "#fff",
                                  borderRadius: 12,
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                                  padding: 18,
                                  marginBottom: 20,
                                  position: "relative",
                                  border: "1px solid #f0f0f0",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: 8,
                                  }}
                                >
                                  <AvatarUtils
                                    value={
                                      itemComment.username
                                        ?.toString()
                                        .split("-")[0] ?? ""
                                    }
                                    show={false}
                                  />
                                  <div style={{ marginLeft: 12, flex: 1 }}>
                                    <Text
                                      size="sm"
                                      fw={600}
                                      style={{ color: "#2d3748" }}
                                    >
                                      {itemComment.username}
                                    </Text>
                                    <Text
                                      size="xs"
                                      c="dimmed"
                                      style={{ fontSize: 12 }}
                                    >
                                      {formatDateTransfer(
                                        itemComment.createdAt
                                      )}
                                    </Text>
                                  </div>
                                  <ActionIcon
                                    variant="light"
                                    aria-label="Xóa bình luận"
                                    color="red"
                                    style={{
                                      position: "absolute",
                                      top: 10,
                                      right: 10,
                                      background: "#fff",
                                      transition: "background 0.2s",
                                    }}
                                    onMouseOver={(e) => {
                                      (
                                        e.currentTarget as HTMLElement
                                      ).style.background = "#ffeaea";
                                    }}
                                    onMouseOut={(e) => {
                                      (
                                        e.currentTarget as HTMLElement
                                      ).style.background = "#fff";
                                    }}
                                    onClick={async () => {
                                      const urlApi =
                                        "/api/v1/SignPage/delete-comment-sign?id=" +
                                        itemComment.id;
                                      var resSign = await repositorySign.get<
                                        MessageResponse<SignAccessModel>
                                      >(urlApi);
                                      if (
                                        resSign &&
                                        resSign.httpStatusCode === 200
                                      ) {
                                        if (!resSign.success)
                                          NotificationExtension.Fails(
                                            resSign.message ?? "Thất bại !"
                                          );
                                        else {
                                          setListComment((x) =>
                                            x?.filter(
                                              (xx) => xx.id !== itemComment.id
                                            )
                                          );
                                        }
                                      }
                                    }}
                                  >
                                    <IconTrash
                                      style={{ width: 22, height: 22 }}
                                      stroke={1.8}
                                    />
                                  </ActionIcon>
                                </div>
                                {itemComment.content && (
                                  <TypographyStylesProvider>
                                    <div
                                      style={{
                                        marginLeft: 44,
                                        marginTop: 2,
                                        fontSize: 15,
                                        color: "#222",
                                        wordBreak: "break-word",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: renderCommentWithMentions(
                                          itemComment.content
                                        ),
                                      }}
                                    />
                                  </TypographyStylesProvider>
                                )}
                                {itemComment.att1 && itemComment.att1.length > 0 && (
                                  <div style={{ marginTop: 8, marginLeft: 44 }}>
                                    <Button
                                      size="xs"
                                      variant="subtle"
                                      color="gray"
                                      leftSection={<IconPaperclip size={16} />}
                                      onClick={() => {
                                        modals.open({
                                          title: "Danh sách tệp đính kèm",
                                          children: (
                                            <AttachmentListModal
                                              fileUrls={
                                                itemComment.att1?.split(",") ||
                                                []
                                              }
                                            />
                                          ),
                                        });
                                      }}
                                    >
                                      {itemComment.att1.split(",").length} tệp{" "}
                                      đính kèm
                                    </Button>
                                  </div>
                                )}
                              </div>
                            ))}
                            {(!listComment || listComment.length === 0) && (
                              <Text c="dimmed" ta="center" mt={40}>
                                Chưa có bình luận nào.
                              </Text>
                            )}
                          </>
                        )}
                      </div>
                    </ScrollArea>
                  </div>
                </div>
              </div>
            </Grid.Col>
          </Grid>

          {/* Popover hiển thị thông tin user */}
          <Popover
            opened={popoverOpened}
            onClose={() => {
              setPopoverOpened(false);
              setPopoverTarget(null);
            }}
            position="top"
            width={320}
            shadow="lg"
            radius="md"
            withArrow
            middlewares={{ flip: true, shift: true }}
            closeOnClickOutside={false}
            closeOnEscape={true}
          >
            <Popover.Target>
              {popoverTarget ? (
                <div
                  style={{
                    position: "fixed",
                    left: popoverTarget.getBoundingClientRect().left,
                    top: popoverTarget.getBoundingClientRect().top,
                    width: popoverTarget.offsetWidth,
                    height: popoverTarget.offsetHeight,
                    pointerEvents: "none",
                    zIndex: 1000,
                    background: "transparent",
                  }}
                />
              ) : (
                <div style={{ display: "none" }} />
              )}
            </Popover.Target>
            <Popover.Dropdown>
              {selectedUser && (
                <div style={{ padding: "8px" }}>
                  <Flex align="center" gap="md" mb="md">
                    <div
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "50%",
                        backgroundColor: selectedUser.avatar
                          ? "transparent"
                          : "#e9ecef",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "24px",
                        fontWeight: "bold",
                        color: "#495057",
                        overflow: "hidden",
                        border: "3px solid #f8f9fa",
                      }}
                    >
                      {selectedUser.avatar ? (
                        <img
                          src={proxyAvatar(selectedUser.avatar, 80)}
                          alt={selectedUser.name}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                          onError={(e) => {
                            // Fallback nếu avatar load lỗi
                            e.currentTarget.style.display = "none";
                            const parent = e.currentTarget.parentElement!;
                            parent.style.backgroundColor = "#e9ecef";
                            parent.innerHTML =
                              selectedUser.name?.charAt(0)?.toUpperCase() ||
                              (selectedUser.isAll ? "ALL" : "U");
                          }}
                        />
                      ) : (
                        selectedUser.name?.charAt(0)?.toUpperCase() ||
                        (selectedUser.isAll ? "ALL" : "U")
                      )}
                    </div>
                    <div style={{ flex: 1 }}>
                      <Text size="lg" fw={600} c="dark.8">
                        {selectedUser.name}
                      </Text>
                      <Text size="sm" c="dimmed">
                        {selectedUser.isAll
                          ? "Nhóm toàn bộ"
                          : `@${selectedUser.userName}`}
                      </Text>
                      {selectedUser.isAll && (
                        <Badge size="xs" color="blue" mt={4}>
                          Báo cáo cho tất cả
                        </Badge>
                      )}
                    </div>
                  </Flex>

                  <Divider mb="md" />

                  {selectedUser.isAll ? (
                    <div>
                      <Flex align="center" gap="xs" mb="sm">
                        <IconUser size={16} color="#666" />
                        <Text size="sm" c="dark.6">
                          Thành viên: {tagUsers.length} người
                        </Text>
                      </Flex>
                      <Text size="xs" c="dimmed">
                        Khi tag @Báo cho cả nhóm, tất cả thành viên trong nhóm
                        sẽ nhận được thông báo.
                      </Text>
                    </div>
                  ) : (
                    <div>
                      <Flex align="center" gap="xs" mb="sm">
                        <IconUser size={16} color="#666" />
                        <Text size="sm" c="dark.6">
                          Tên đăng nhập: {selectedUser.userName}
                        </Text>
                      </Flex>

                      <Flex align="center" gap="xs" mb="sm">
                        <IconMail size={16} color="#666" />
                        <Text size="sm" c="dark.6">
                          Email:{" "}
                          {selectedUser.email ||
                            `${selectedUser.userName}@htc.vn`}
                        </Text>
                      </Flex>

                      {selectedUser.phone && (
                        <Flex align="center" gap="xs" mb="sm">
                          <IconCalendar size={16} color="#666" />
                          <Text size="sm" c="dark.6">
                            Điện thoại: {selectedUser.phone}
                          </Text>
                        </Flex>
                      )}

                      {selectedUser.address && (
                        <Flex align="center" gap="xs" mb="sm">
                          <IconCalendar size={16} color="#666" />
                          <Text size="sm" c="dark.6">
                            Địa chỉ: {selectedUser.address}
                          </Text>
                        </Flex>
                      )}

                      <Flex align="center" gap="xs" mb="sm">
                        <IconCalendar size={16} color="#666" />
                        <Text size="sm" c="dark.6">
                          Trạng thái: Đang hoạt động
                        </Text>
                      </Flex>

                      <Text size="xs" c="dimmed" mt="md">
                        Nhấn vào tên người dùng để gửi thông báo trực tiếp.
                      </Text>
                    </div>
                  )}
                </div>
              )}
            </Popover.Dropdown>
          </Popover>
        </>
      )}

      {!documentData && !documentInfo && <Loading />}
    </>
  );
};

export default ViewTopage;
//che
